import axios from 'axios';
import { Auth } from 'aws-amplify';
import axiosInstance from './axios';
import NotificationAlert from "../components/notification";

export async function getAPI(path: string) {   

    try {
        const response: any = await axiosInstance.get(path, {
            // headers: {
            //     'Authorization': `Bearer ${localStorage.getItem('Token')}`
            //     }
        })
        return response
    } catch (e: any) {
        if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' ){
            Auth.signOut()
        }
        return { error: e.toString() }
    }

}

export async function postAPI(path: string, body: any) {
    
    try {
        const response: any = await axiosInstance.post(path, body)        
        return response
    } catch (e: any) {
        if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' ){
            Auth.signOut()
        }
        return { error: e.toString(), errorResponse: e.response.data }
    }

}


export async function uploadPostAPI(path: string, body: any) {
    try {
        const response: any = await axiosInstance.post(path, body)
        return response
    } catch (e: any) {
        if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' ){
             
            Auth.signOut()
        }
        return { error: e.toString() }
    }
}

export async function putAPI(path: string, body: any) {
    try {
        const response: any = await axiosInstance.put(path, body)
        return response
    } catch (e: any) {
        if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' ){
             
            Auth.signOut()
        }
        return { error: e.toString() }
    }
}

export async function uploadApi(path: string, body: any, type: any) {
    
    // try {
    //     const response: any = await axiosInstance.put(path, body, {
    //                 headers: {
    //                     'Content-Type': type
    //                 }
    //             })
    //     return response
    // } catch (e: any) {
    //     if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' ){
             
    //         Auth.signOut()
    //     }
    //     return { error: e.toString() }
    // }
    try {
        const response = await axios.put(path, body, {
            headers: {
                'Content-Type': type
            }
        })
        return response.data
    } catch (e: any) {
        if (e.response.status === 401) {
          //  clearStorage();
        }

        return { error: e.toString() }
    }
}

export async function deleteAPI(path: string) {
    try {
        const response: any = await axiosInstance.delete(path, {
            method: 'DELETE',
        })
        return response
    } catch (e: any) {
        if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' ){
             
            Auth.signOut()
        }
        return { error: e.toString() }
    }
    // try {
    //     const response = await axios.delete(path, {
    //         method:'DELETE',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //     })
    //     return response.data
    // } catch (e: any) {
    //     return { error: e.toString() }
    // }
}

export async function EmbeddedPostAPI(path: any, body: any) {
    try {
        const response = await axios.post(path, body, {
            "headers":{
                "Content-Type":"application/json",
                },
                'auth': { 
                    username:'fd9eb286ef2dbcad7bfc907a11b841716179a42d678534b78f92f033b90bca1b',
                    password:''
                }
        });
        return response.data
    } catch (e: any) {
        return { error: e.response }
    }
}

export async function EmbeddedgetAPI(path: any) {
    try {
        const response = await axios.get(path, {
            'auth': { 
                username:'fd9eb286ef2dbcad7bfc907a11b841716179a42d678534b78f92f033b90bca1b',
                password:''
            }
        });
        return response.data
    } catch (e: any) {
        return { error: e.toString() }
    }
}

